module.exports = Em.Route.extend({
    resetController: function(controller) {
        controller.set('importStats', null)
    }
})
